<template>
  <v-container style="height: 100%"  v-if="$route.name === 'ListDissSovet'">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Список советов:</span>
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-1 ma-1"
          label="Поиск по наименованию"
          v-model="findCode"
        >
        </v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItemsClear" color="primary" icon flat><v-icon>clear</v-icon></v-btn>
          </template>
          <span>Очистить поля ввода</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItems" color="primary" icon flat><v-icon>search</v-icon></v-btn>
          </template>
          <span>Поиск</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :rows-per-page-items="[5,15,35,{text:'Все', value:-1}]"
              class="elevation-1  "
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <tr class="justify-center"  @click="goPath(props.item)"  style="cursor:pointer">
                <td class="justify-center">
                  {{props.item.code}}
                </td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.scientificFieldData"  >
                     {{item}}
                  </div>
                </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
  <div v-else>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>


<script>

    import urls from "../../../../modules/petition/urls"
    import UserDataMixin from '../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../helper";

    export default {
        name: "ListDissertation_council",

        mixins: [UserDataMixin],

        data: function () {
            return {

                URL_LIST: urls.getUrl('admin|diss|models|dissertation_council-list', 'list'),
                URL_DELETE: urls.getUrl('admin|diss|models|dissertation_council-detail', 'update'),
                selectors:{
                    scientificField:[],
                },
                findCode: "",
                headers: [
                    {
                        text: 'Наименование', sortable: false, align: 'justify-center',
                        value: 'name',
                        // class: 'headline'
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ],

            }
        },
        methods: {
            getItemsClear(){
                this.findCode = "";
                this.getItems()
            },
            goPath(item){
              let paramR = {id: item.id}
              if(this.$route.params.token){
                paramR = {id: item.id, token:this.$route.params.token}
              }

                this.$router.push({name:'CurrentDissSovet', params: paramR})
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
            findNameObj(edit,id){
                let obj = this.selectors[edit].find(item => item.value === id);
                if (obj !== undefined) {
                    return obj.text
                }else{
                    return ""
                }
            },
            getItems(){
                let url = new URL(this.URL_LIST)
                let params = {};
                if(this.findCode.length !== 0)
                    params.code__icontains = this.findCode

                url.search = new URLSearchParams(params).toString();

                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }) .then(jsonD => {
                    this.items = jsonD;

                    for (let i in jsonD) {
                        let str = i
                        let url = new URL(process.env.VUE_APP_API_HOST + "council/admin/diss/models/dissertation_council_scientific_field/")

                        let params = jsonD[str].scientificField.get_params
                        // json.scientificField.get_params.page_size = 100
                        url.search = new URLSearchParams(params).toString();

                        makeGetRequest(url).then(resp => {
                            if (!resp.ok) {
                                sys = false
                            }
                            return resp.json()
                        }) .then(json => {
                            let answ =[]
                            for (let k in json) {
                                answ.push(this.findNameObj('scientificField',json[k].scientificField))
                            }
                            this.$set(this.items[str], 'scientificFieldData', "-") //  создаем новое реактивное св-во
                            this.items[str].scientificFieldData = answ;
                        })
                    }
                })
            },
            addItem(){
                this.getItems();
            },
        },
        created() {
            this.loadSelector("scientificField", urls.getUrl('admin|core|selectors|scientific_field', 'get'))
            this.getItems();
            this.$store.commit('mainpage/changeTitle', 'Диссертационный совет');
        },
    }


</script>
<style scoped>

</style>
